import { ApiService }               from '../../app-lite/api/api.service';
import { ChargifyService }          from '../../app-lite/chargify/chargify.service';
import { CodeTypeModel }            from '../../app-lite/core/models/code-type';
import { CompanyService }           from '../../app-lite/companies/company.service';
import { CompanySubscriptionModel } from '../../app-lite/companies/models/company.subscription';
import { CompanyValidationsModel }  from '../../app-lite/companies/models/company.validations';
import { ConfirmService }           from '../../app-lite/messages/confirm/confirm.service';
import { FileUploadOptionsModel }   from '../../app-lite/shared/controls/file-upload-control/typings/file-upload.options';
import { JsonService }              from '../../app-lite/core/services/json.service';
import { TranslateConfigService }   from '../../app-lite/internationalization/translate-config.service';

import CompanyProfileHtml      from './templates/company.profile.html';
import CompanySubscriptionHtml from './templates/company.subscription.html';

export class CompanyCtrl {
  $rootScope        : any;
  $scope            : ng.IScope;
  $state            : ng.ui.IStateService;
  $translate        : ng.translate.ITranslateService;
  balance           : number;
  block             : ng.blockUI.BlockUIService;
  company           : any;
  Company           : any;
  confirm           : ConfirmService;
  countries         : Array<CodeTypeModel>
  dealership_status : string;
  languages         : Array<any>;
  letterheadOptions : FileUploadOptionsModel;
  logoOptions       : FileUploadOptionsModel;
  messages          : any;
  payment_period    : string;
  price_of_package  : number;
  states            : Array<CodeTypeModel>;
  subscription      : CompanySubscriptionModel;
  subscription_plan : string;
  tabs              : Array<any>;
  validations       : CompanyValidationsModel;
  workshopAPI       : ApiService;

  addressSearch       : any = {
    list    : [],
    selected: {
      full_address: '',
      id          : ''
    },
    search: ( typed : string ) => {
      return this.workshopAPI.get('/NzPostal/get_addresses', typed)
      .then(addresses => addresses !== 'null' ? addresses : '');
    },
    choose: ( address : any ) => {
      return this.workshopAPI.get('/NzPostal/get_address_details', address.address_id)
      .then(( address : any ) => {
        this.company.address1     = address.address1;
        this.company.address2     = address.address2;
        this.company.country_code = address.country_code;
        this.company.latitude     = address.latitude;
        this.company.longitude    = address.longitude;
        this.company.postcode     = address.postcode;
        this.company.state        = address.state;
        this.company.suburb       = address.suburb;
      });
    },
    format: () => angular.isString(this.company.address1) ? this.company.address1 : ''
  };

  constructor (
    $rootScope                : any,
    $scope                    : ng.IScope,
    $state                    : ng.ui.IStateService,
    $translate                : ng.translate.ITranslateService,
    blockUI                   : ng.blockUI.BlockUIService,
    private chargifyApi       : ChargifyService,
    company                   : any,
    companyApi                : CompanyService,
    confirm                   : ConfirmService,
    countries                 : Array<CodeTypeModel>,
    private jsonApi           : JsonService,
    languages                 : Array<any>,
    messages                  : any,
    states                    : Array<CodeTypeModel>,
    private translateConfigApi: TranslateConfigService,
    workshopAPI               : ApiService
  ) {
    this.$rootScope  = $rootScope;
    this.$state      = $state;
    this.$scope      = $scope;
    this.$translate  = $translate;
    this.block       = blockUI.instances.get('companyBlock');
    this.company     = company;
    this.Company     = companyApi;
    this.confirm     = confirm;
    this.countries   = countries;
    this.languages   = languages;
    this.messages    = messages;
    this.states      = states;
    this.workshopAPI = workshopAPI;

    this.letterheadOptions = {
      accept       : 'images',
      file         : this.Company.getLetterhead(),
      height       : 150,
      size         : 2000000,
      type         : 'letterhead',
      updateVersion: true,
      width        : 150,
    };

    this.logoOptions = {
      accept       : 'images',
      file         : this.Company.getLogo(),
      height       : 50,
      size         : 200000,
      type         : 'logo',
      updateVersion: true,
      width        : 50
    };

    this.tabs = [
      {
        active : true,
        content: CompanyProfileHtml,
        title  : 'Company Details'
      }
    ];

    this.init();
  }

  addDealership () : void {
    this.Company.addDealership()
    .then(() => {
      this.messages.show(this.$translate.instant('COMPANY_SPACE.CHARGIFY.ADD_DEALERSHIP_SUCCESSFUL'), 'success');

      this.$state.reload();
    })
    .catch(( err : any ) => {
      this.messages.error(err);
    });
  }

  annualSubscription () : void {
    this.Company.annualSubscription()
    .then(() => {
      this.messages.show(this.$translate.instant('COMPANY_SPACE.CHARGIFY.ANNUAL_SUCCESSFUL_SUBSCRIPTION'), 'success');
    })
    .catch(( err : any ) => {
      this.messages.error(err);
    });
  }

  buySMS () : ng.IPromise<void> {
    return this.Company.buySms()
    .then(( count : number ) => {
      this.company.sms_count_left = count;
    });
  }

  cancelSubscription () : void {
    this.Company.cancelSubscription(this.subscription)
    .then(() => {
      this.messages.show(this.$translate.instant('COMPANY_SPACE.CHARGIFY.CANCEL_SUBSCRIPTION_SUCCESSFUL'), 'success');

      this.$state.reload();
    })
    .catch(( err : any ) => {
      this.messages.error(err);
    });
  }

  getSubscription () : void {
    this.chargifyApi.getSubscription(this.company)
    .then(( subscription : CompanySubscriptionModel ) => {
      this.subscription = subscription;

      return subscription;
    })
    .then(() => {
      this.tabs.push({
        active : false,
        content: CompanySubscriptionHtml,
        disable: !this.subscription,
        title  : this.subscription ? 'Subscription' : this.$translate.instant('COMPANY_SPACE.SUBSCRIPTION.NOT_FOUND')
      });

      if (this.subscription) {
        this.balance          = this.subscription.balance_in_cents / 100;
        this.price_of_package = this.subscription.current_billing_amount_in_cents / 100;

        switch (this.subscription.product.handle) {
          case 'ds_silver_year':
            this.dealership_status = 'Yes';
            this.payment_period    = 'Yearly';
            this.subscription_plan = 'Silver';
            break;
          case 'ds_gold_year':
            this.dealership_status = 'Yes';
            this.payment_period    = 'Yearly';
            this.subscription_plan = 'Gold';
            break;
          case 'ds_plat_year':
            this.dealership_status = 'Yes';
            this.payment_period    = 'Yearly';
            this.subscription_plan = 'Platinum';
            break;
          case 'ds_silver_month':
            this.dealership_status = 'Yes';
            this.payment_period    = 'Monthly';
            this.subscription_plan = 'Silver';
            break;
          case 'ds_gold_month':
            this.dealership_status = 'Yes';
            this.payment_period    = 'Monthly';
            this.subscription_plan = 'Gold';
            break;
          case 'ds_plat_month':
            this.dealership_status = 'Yes';
            this.payment_period    = 'Monthly';
            this.subscription_plan = 'Platinum';
            break;
          case 'wksw_plat':
            this.dealership_status = 'No';
            this.payment_period    = 'Monthly';
            this.subscription_plan = 'Platinum';
            break;
          case 'wksw_gold':
            this.dealership_status = 'No';
            this.payment_period    = 'Monthly';
            this.subscription_plan = 'Gold';
            break;
          case 'wksw':
            this.dealership_status = 'No';
            this.payment_period    = 'Monthly';
            this.subscription_plan = 'Silver';
            break;
          case 'wksw_bronze':
            this.dealership_status = 'No';
            this.payment_period    = 'Monthly';
            this.subscription_plan = 'Bronze';
            break;
          case 'wkswm_gold':
            this.dealership_status = 'No';
            this.payment_period    = 'Monthly';
            this.subscription_plan = 'Gold';
            break;
          case 'wkswm':
            this.dealership_status = 'No';
            this.payment_period    = 'Monthly';
            this.subscription_plan = 'Silver';
            break;
          case 'wksw12_bronze':
            this.dealership_status = 'No';
            this.payment_period    = 'Yearly';
            this.subscription_plan = 'Bronze';
            break;
          case 'wksw12':
            this.dealership_status = 'No';
            this.payment_period    = 'Yearly';
            this.subscription_plan = 'Silver';
            break;
          case 'wksw12_gold':
            this.dealership_status = 'No';
            this.payment_period    = 'Yearly';
            this.subscription_plan = 'Gold';
            break;
          case 'wksw12_plat':
            this.dealership_status = 'No';
            this.payment_period    = 'Yearly';
            this.subscription_plan = 'Platinum';
            break;
        }
      }
      else {
        this.balance           = 0;
        this.price_of_package  = 0;
        this.dealership_status = 'N/A';
        this.payment_period    = 'N/A';
        this.subscription_plan = 'N/A';
      }
    });
  }

  getValidations () {
    this.workshopAPI.get('/system/country_validations', this.company.country_code)
    .then(( validations : CompanyValidationsModel ) =>{
      this.validations = validations;
    })
    .catch(( err : any ) => {
      this.messages.error(err);
    });
  }

  init () {
    const queryParameters = this.jsonApi.getQueryParameters();

    this.getSubscription();
    this.getValidations();

    if (queryParameters.first_login) {
      this.Company.setUp()
      .then(() => {
        this.$state.go('app.company', {
          first_login: null
        }, {
          inherit: false,
          reload : true
        });
      });
    }
  }

  removeDealership () : ng.IPromise<void> {
    return this.confirm.generic(this.$translate.instant('JS_SPACE.INTEGRATIONS.DEACTIVATE', { name: 'Dealership' }))
    .then(() => this.workshopAPI.get('/company/remove_dealership'))
    .then(() => {
      this.messages.show(this.$translate.instant('COMPANY_SPACE.SUBSCRIPTION.DEALERSHIP_SUCCESSFULLY_REMOVED'), 'success');

      this.$state.reload();
    });
  }

  reverseCancellation () : void {
    this.confirm.generic('Are you sure you want to reverse your cancellation of Workshop Software? Please Note: this can be done any time up until your cancellation date')
    .then(() => this.workshopAPI.post('/chargify/cancel_subscription_reversal', this.subscription, 'subscription'))
    .then(() => {
      this.messages.show(this.$translate.instant('COMPANY_SPACE.CHARGIFY.CANCEL_SUBSCRIPTION_REVERSAL_SUCCESSFUL'), 'success');

      this.$state.reload();
    })
    .catch(( err : any ) => {
      this.messages.error(err);
    });
  }

  save ( form : ng.IFormController ) : void {
    this.block.start();

    this.workshopAPI.patch('/company', this.company, 'company')
    .then(( company : any ) => {
      this.messages.show(this.$translate.instant('JS_SPACE.MESSAGES.SAVED.PROFILE'), 'success');

      form.$setPristine();

      // AngularJS translations
      this.$translate.use(company.language);

      // Angular translations
      this.translateConfigApi.setLanguage(company.language);

      this.$state.reload();
    })
    .catch(( err : any ) => {
      this.messages.error(err);
    })
    .finally(() => {
      this.block.stop();
    });
  }

  updatePaymentDetails () : void {
    this.Company.updateSubscriptionPayment(this.subscription)
    .then(() => {
      this.messages.show(this.$translate.instant('COMPANY_SPACE.CHARGIFY.UPDATE_PAYMENT_DETAILS_SUCCESSFUL'), 'success');

      this.$state.reload();
    });
  }

  updateStates = function () {
    this.workshopAPI.get('/system/states_for_country', this.company.country_code)
    .then(( states : Array<CodeTypeModel> ) => {
      this.states = states;

      this.getValidations();
    })
    .catch(( err : any ) => {
      this.messages.error(err);
    });
  }
}
